<template>
    <div class="my-get-select-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>
        <!-- 2. 主要内容部分 -->
        <div class="my-get-select-top-bar dsp-flex">
            <div class="layout-glt-half">
                <p class="my-get-select-title">共享记录列表（{{curShareRecordList.length}}条）</p>
                <div class="layout-glt-choose">                        
                    <span @click.stop="selectAll">全选</span>
                    <span @click.stop="invertAll">反选</span>   
                </div>
            </div>
            <!-- 年月日时部分 -->
            <div class="layout-glt-note" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                <span class="title-span"><span v-for="string in stringArr" :key="string">{{string}}</span></span>
            </div>
        </div>
        <div class="my-get-list-content">
            <virtual-list id="MyGetList" ref="vsl" class="layout-my-get-list scroll-touch"
                :data-key="'id'"
                :data-sources="curShareRecordList"
                :data-component="itemComponent"
                :estimate-size="20"
                :item-class="'list-item-fixed'"

                :footer-class="'famous-list-note'"
                v-on:tobottom="onScrollToBottom">
                <div v-show="parseInt(curShareData.nowpage) < parseInt(curShareData.totalpage)" slot="footer" class="lds-dual-ring lds-dual-ring-gray"></div>
            </virtual-list>
        </div>
        <div class="my-get-bottom-bar">
            <div class="my-get-bottom-group" @click="chooseGroup">选择接收分组：<span>{{choosedGroup && choosedGroup.f_name ? choosedGroup.f_name.slice(0, 6) : '未分组'}}<i class="iconfont icon-xiangyou"></i></span></div>
            <div class="my-get-bottom-button" @click="clickSure">
                <span class="button-text" v-if="curShareSelectList.length == 0">选择接收记录</span>
                <span class="button-text" v-else>接 收({{curShareSelectList.length}})</span>
            </div>
        </div>
        <router-view></router-view>

        <!-- 接收成功弹框 -->
        <van-popup class="my-get-suc-pop" position="center" :value="showPop" :close-on-click-overlay="false">
            <div class="my-get-suc-title" v-if="curPercent < 100">服务器正在导出备份</div>
            <div class="my-get-suc-title" v-else>接收完成，共接收{{curShareSelectList.length}}条记录</div>
            <div class="my-get-suc-p-bar">
                <div class="my-get-suc-p-bar-bg"></div>
                <div class="my-get-suc-p-bar-cur" :style="'width: '+curPercent+'%'"></div>
            </div>
            <div class="my-get-suc-text">{{curPercent}}%</div>
        </van-popup>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import RecordYmdTitle from '../../components/record/RecordYmdTitle.vue'
import GetChooseItem from '../../components/my/GetChooseItem.vue'
import { UTILS } from '../../modules/utils'
export default {
    name: 'MyGetSelect',
    components: { TitleBar, RecordYmdTitle },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        curShareData() {
            return this.$store.state.record.curShareData;
        },
        curShareRecordList() {
            return this.$store.state.record.curShareRecordList;
        },
        curShareSelectList() {
            return this.$store.state.record.curShareSelectList;
        },
        choosedGroup() {
            return this.$store.state.group.choosedGroup;
        },
    },
    data() {
        return {
            stringArr: ['年', '月', '日', '时'],
            titleData: {'titleText': '接收共享记录', 'showCancel': false},
            itemComponent: GetChooseItem,
            showPop: false,
            curPercent: 0,
            curTimeFunc: undefined
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
            var titleDom = document.getElementsByClassName('title-bar')[0],
                topbarDom = document.getElementsByClassName('my-get-select-top-bar')[0],
                contentDom = document.getElementsByClassName('my-get-list-content')[0];
            // console.error('initDom-------', titleDom, topbarDom, contentDom)
            var height = titleDom ? titleDom.clientHeight : 0;
                height = topbarDom ? height+topbarDom.clientHeight : height;
            if(contentDom) {
                contentDom.style.height = innerHeight+'px';
                contentDom.style.paddingTop = height+'px';
            }
            var listDom = document.getElementById('MyGetList');
            var bottomDom = document.getElementsByClassName('my-get-bottom-bar')[0];
                height = bottomDom ? height+bottomDom.clientHeight : height;
            if(listDom) {
                listDom.style.height = (innerHeight-height)+'px';
            }
        },
        clickBack() {
            this.$store.dispatch('group/resetChooseGroupData');
            this.$router.replace('/my/getbz');
        },
        onScrollToBottom() {
            console.error('onScrollToBottom----')
            var me = this;
            this.$store.dispatch('record/getShareCodeInfo', {
                failCb: function() {
                    me.$toast('分享码错误，请重新输入')
                }
            })
        },
        selectAll() {
            var curSelectList = this.$store.state.record.curShareRecordList;
            this.$store.state.record.curShareSelectList = [].concat(curSelectList);
            this.$store.dispatch('record/setShareListSelect', {
                arr: curSelectList, selected: true
            });
        },
        invertAll() {
            var tempList = [],
                curSelectList = this.$store.state.record.curShareSelectList,
                curShareList = this.$store.state.record.curShareRecordList;
            curShareList.forEach(element => {
                var curIndex = UTILS.getIdIndexInObjectArray(curSelectList, element.id);
                if(curIndex == -1) {
                    tempList.push(element);
                }
            })
            this.$store.dispatch('record/setShareListSelect', {
                arr: curSelectList, selected: false
            });
            this.$store.dispatch('record/setShareListSelect', {
                arr: tempList, selected: true
            });
            this.$store.state.record.curShareSelectList = [].concat(tempList);
        },
        chooseGroup() {
            this.$router.replace('/my/getbzselect/choosegroup');
        },
        clickSure() {
            if(this.curShareSelectList.length == 0) {
                this.$toast('请先选择要接收的八字数据');
                return;
            }
            let userVip = this.$store.state.userData.vip;
            if((userVip == 0 && this.curShareSelectList.length >= 32) || (userVip == 10 && this.curShareSelectList.length >= 64)) {
                let tText = userVip == 0 ? '非会员每次最多只能接收32个八字数据，你可以升级成会员以便享用更多的会员特权。' : '月会员每次最多只能接收64个八字数据，你可以升级成年会员以便享用更多的会员特权。';
                this.$toast({
                    message: tText,
                    className: 'van-toast--width-80',
                });
                this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'accept'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }
            let me = this;
            this.$store.dispatch('record/saveSelectShareList', {
                groupId: me.choosedGroup ? me.choosedGroup.id : 0,
                sucCb: function() {
                    me.showPop = true;
                    me.startPercentAni();
                }
            });
        },
        startPercentAni() {
            var me = this, startNum = this.curPercent;
            function count() {
                var addNum = UTILS.getRandomInt(5);
                if(startNum+addNum <= 100) {
                    startNum = startNum+addNum;
                    me.curPercent = startNum;
                    me.curTimeFunc = setTimeout(() => {
                        count();
                    }, UTILS.getRandomInt(100));
                }else {
                    me.curPercent = 100;
                    setTimeout(() => {
                        me.$router.replace('/record');
                        me.$store.state.record.gotRecordRecentlyData = false;
                        me.$store.dispatch('record/initRecordRecentlyList');
                        me.$store.state.record.gotRecordData = false;
                        me.$store.dispatch('record/initRecordList');
                        me.$store.dispatch('record/resetShareData');
                    }, 20);
                    clearTimeout(me.curTimeFunc);
                }
            }
            count();
        }
    }
}
</script>